import { render } from "./userListOrders.vue?vue&type=template&id=deec90b4&scoped=true"
import script from "./userListOrders.vue?vue&type=script&lang=js"
export * from "./userListOrders.vue?vue&type=script&lang=js"

import "./userListOrders.vue?vue&type=style&index=0&id=deec90b4&scoped=true&lang=css"
import "./userListOrders.vue?vue&type=style&index=1&id=deec90b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deec90b4"]])

export default __exports__